import { useState } from 'react'
import { SignupForm } from './signup-form'
import { SignupOtpForm, type SignupOtpState } from './signup-otp-form'

export function SignupWorkflow(props: { onSuccess: () => Promise<void> }) {
	const [signupOtp, setSignupOtp] = useState<SignupOtpState | null>(null)

	if (signupOtp) {
		return (
			<SignupOtpForm
				{...signupOtp}
				onBack={() => setSignupOtp(null)}
				onRequiresOtp={setSignupOtp}
				onSuccess={props.onSuccess}
			/>
		)
	}

	return (
		<SignupForm onRequiresOtp={setSignupOtp} onSuccess={props.onSuccess} />
	)
}
